import { IClassname } from '@/lib/shared/model/classname';

export const PrivateGarden = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.0001 23.8265V26.9571C28.0001 27.2338 27.8901 27.4992 27.6945 27.6949C27.4988 27.8906 27.2333 28.0006 26.9566 28.0006H5.04302C4.76626 28.0006 4.50084 27.8906 4.30515 27.6949C4.10945 27.4992 3.99951 27.2338 3.99951 26.9571V16.522C3.99951 16.2453 4.10945 15.9798 4.30515 15.7842C4.50084 15.5885 4.76626 15.4785 5.04302 15.4785H26.9566C27.2333 15.4785 27.4988 15.5885 27.6945 15.7842C27.8901 15.9798 28.0001 16.2453 28.0001 16.522V23.8265Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.78516 10.7695C8.69509 11.8934 10.2603 13.7988 10.2603 15.4789"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6345 10.6396C11.7214 11.7635 10.2605 13.7994 10.2605 15.4784"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.04297 9.73908C5.04297 10.1542 5.20788 10.5523 5.50142 10.8459C5.79496 11.1394 6.19309 11.3043 6.60822 11.3043C7.02336 11.3043 7.42148 11.1394 7.71503 10.8459C8.00857 10.5523 8.17348 10.1542 8.17348 9.73908C8.17348 9.32395 8.00857 8.92582 7.71503 8.63228C7.42148 8.33874 7.02336 8.17383 6.60822 8.17383C6.19309 8.17383 5.79496 8.33874 5.50142 8.63228C5.20788 8.92582 5.04297 9.32395 5.04297 9.73908Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3481 9.73908C12.3481 10.1542 12.5131 10.5523 12.8066 10.8459C13.1001 11.1394 13.4983 11.3043 13.9134 11.3043C14.3285 11.3043 14.7267 11.1394 15.0202 10.8459C15.3137 10.5523 15.4787 10.1542 15.4787 9.73908C15.4787 9.32395 15.3137 8.92582 15.0202 8.63228C14.7267 8.33874 14.3285 8.17383 13.9134 8.17383C13.4983 8.17383 13.1001 8.33874 12.8066 8.63228C12.5131 8.92582 12.3481 9.32395 12.3481 9.73908Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.69556 5.56526C8.69556 5.98039 8.86047 6.37852 9.15401 6.67206C9.44755 6.9656 9.84568 7.13051 10.2608 7.13051C10.6759 7.13051 11.0741 6.9656 11.3676 6.67206C11.6612 6.37852 11.8261 5.98039 11.8261 5.56526C11.8261 5.15012 11.6612 4.75199 11.3676 4.45845C11.0741 4.16491 10.6759 4 10.2608 4C9.84568 4 9.44755 4.16491 9.15401 4.45845C8.86047 4.75199 8.69556 5.15012 8.69556 5.56526Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2175 5.56526C21.2175 5.98039 21.3824 6.37852 21.676 6.67206C21.9695 6.9656 22.3677 7.13051 22.7828 7.13051C23.1979 7.13051 23.596 6.9656 23.8896 6.67206C24.1831 6.37852 24.348 5.98039 24.348 5.56526C24.348 5.15012 24.1831 4.75199 23.8896 4.45845C23.596 4.16491 23.1979 4 22.7828 4C22.3677 4 21.9695 4.16491 21.676 4.45845C21.3824 4.75199 21.2175 5.15012 21.2175 5.56526Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4084 10.6396C21.3215 11.7635 22.7824 13.7983 22.7824 15.4784"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.2623 10.7695C24.3482 11.8934 22.783 13.7999 22.783 15.4789"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5649 9.73908C17.5649 10.1542 17.7299 10.5523 18.0234 10.8459C18.3169 11.1394 18.7151 11.3043 19.1302 11.3043C19.5453 11.3043 19.9435 11.1394 20.237 10.8459C20.5305 10.5523 20.6955 10.1542 20.6955 9.73908C20.6955 9.32395 20.5305 8.92582 20.237 8.63228C19.9435 8.33874 19.5453 8.17383 19.1302 8.17383C18.7151 8.17383 18.3169 8.33874 18.0234 8.63228C17.7299 8.92582 17.5649 9.32395 17.5649 9.73908Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8694 9.73908C24.8694 10.1542 25.0343 10.5523 25.3278 10.8459C25.6214 11.1394 26.0195 11.3043 26.4346 11.3043C26.8498 11.3043 27.2479 11.1394 27.5414 10.8459C27.835 10.5523 27.9999 10.1542 27.9999 9.73908C27.9999 9.32395 27.835 8.92582 27.5414 8.63228C27.2479 8.33874 26.8498 8.17383 26.4346 8.17383C26.0195 8.17383 25.6214 8.33874 25.3278 8.63228C25.0343 8.92582 24.8694 9.32395 24.8694 9.73908Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2605 15.4779V7.12988"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.783 15.4779V7.12988"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.12891 19.6523H24.8685"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.12891 23.8262H24.8685"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.12891 28.0006V15.4785"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8689 28.0006V15.4785"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
